const PaxsHotel = (state) => state.PaxsHotel
const PaxsHotelRooms = (state) => state.PaxsHotelRooms

export default {
  PaxsHotel,
  PaxsHotelRooms
}
